import { Grid as MuiGrid, Typography as MuiTypography } from "@mui/material";
import InfoCard from "./InfoCard";
import BigMetric from "./BigMetric";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ParticipantEngagementCard = ({
  honestBrokerStatus,
  contactedCount,
  respondedCount,
  positiveResponseCount,
}) => {
  const { t } = useTranslation();
  const isHonestBrokerAssigned = honestBrokerStatus === "ASSIGNED";
  return (
    <InfoCard
      title={t("studyInsights.participantEngagementActivity")}
      helpText={
        "The Participant Engagement Card provides a quick overview of the Honest Broker related activity for your study. It displays the number of participants contacted, the number who responded, and the number who positively responded with interest."
      }
    >
      <MuiGrid
        container
        spacing={4}
        sx={{ justifyContent: "center", alignItems: "flex-start" }}
      >
        {isHonestBrokerAssigned && (
          <>
            <MuiGrid size={{ xs: 12, md: 4 }} sx={{ textAlign: "center" }}>
              <BigMetric
                value={contactedCount}
                label="Number of people that were contacted"
              />
            </MuiGrid>
            <MuiGrid size={{ xs: 12, md: 4 }} sx={{ textAlign: "center" }}>
              <BigMetric
                value={respondedCount}
                label="Number of people that responded"
              />
            </MuiGrid>
            <MuiGrid size={{ xs: 12, md: 4 }} sx={{ textAlign: "center" }}>
              <BigMetric
                value={positiveResponseCount}
                label="Number of people that positively responded with interest"
              />
            </MuiGrid>
          </>
        )}
        {!isHonestBrokerAssigned && (
          <MuiGrid size={{ xs: 12 }} sx={{ textAlign: "center" }}>
            <MuiTypography variant="body2" color="textSecondary">
              When your study uses the Participant Engagement Service, this card
              displays three key metrics that track your outreach effectiveness:
              the total number of participants contacted, how many responded to
              your outreach, and how many expressed positive interest in
              participating. These metrics help you quickly assess the success
              of your recruitment efforts and identify opportunities to improve
              engagement with potential study participants.
            </MuiTypography>
          </MuiGrid>
        )}
      </MuiGrid>
    </InfoCard>
  );
};

ParticipantEngagementCard.propTypes = {
  honestBrokerStatus: PropTypes.string,
  contactedCount: PropTypes.number.isRequired,
  respondedCount: PropTypes.number.isRequired,
  positiveResponseCount: PropTypes.number.isRequired,
};

export default ParticipantEngagementCard;
